import React, { useEffect, useState } from "react";
import PageHeader from "@/components/PageHeader";

export default function TermsConditionsPage() {
  return (
    <main className="min-h-screen my-14 px-4 flex justify-center">
      <div className="w-full max-w-4xl">
        
        {/* Header */}
        <PageHeader>Terms & Conditions</PageHeader>

        {/* Card */}
            <section className="bg-white shadow-xl border border-pink-100 rounded-2xl p-6 md:p-10 mt-6">

          {/* Intro */}
          <p className="text-gray-700 leading-relaxed mb-6">
           Accessing this website means you accept and agree to be bound by our terms, conditions, and applicable legal requirements.
          </p>

          <hr className="my-6 border-gray-200" />

          {/* Delivery & Shipping Policy */}
          <div className="mb-8">
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              Delivery & Shipping Policy
            </h2>

            <ul className="space-y-3 text-gray-700 list-disc pl-5">
              <li>
                Free delivery is available on orders above ₹1000.
              </li>
              <li>
               Orders below ₹1000 will incur a shipping charge of ₹80 per parcel.
              </li>
              <li>
                Delivery time typically ranges between 3–7 business days, depending on the delivery location.
              </li>
            </ul>
          </div>

          <hr className="my-6 border-gray-200" />

          {/* Return Policy */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              Pricing & Payment Policy
            </h2>

            <ul className="space-y-3 text-gray-700 list-disc pl-5">
              <li>
                Prices will be in INR including GST.
              </li>
              <li>
                Supported Payment Methods (UPI,CARDS,COD)
              </li>
              <li>
                To cancel an order, customers must contact us immediately via email or WhatsApp.Once the order has been dispatched, cancellation will not be allowed.
              </li>
            </ul>
          </div>
          
          <hr className="my-6 border-gray-200" />

          {/* Color Difference */}
          <div>
            <h2 className="text-xl md:text-xl mb-4 text-black">
              We reserve the right to update or modify these Terms & Conditions at any time without prior notice. Any changes will be effective immediately upon being posted on our website. Customers are advised to review these Terms periodically for any updates.
            </h2>
          </div>

          <hr className="my-6 border-gray-200" />

          <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              ❤ We can’t wait to see you back at AURA GIRL!
            </h2>
          </div>

        </section>
      </div>
    </main>
  );
}

